import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=00a0051a&"
import script from "./Notes.vue?vue&type=script&lang=js&"
export * from "./Notes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00a0051a')) {
      api.createRecord('00a0051a', component.options)
    } else {
      api.reload('00a0051a', component.options)
    }
    module.hot.accept("./Notes.vue?vue&type=template&id=00a0051a&", function () {
      api.rerender('00a0051a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/Notes.vue"
export default component.exports